import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 232px)',
    '& #next-button': {
      [theme.breakpoints.down('lg')]: {
        width: 110,
      },
      [theme.breakpoints.down('md')]: {
        width: 200,
      },
    },
  },
  order: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  saveForLaterContainer: {
    marginTop: '40px',
    [theme.breakpoints.down('lg')]: {
      marginTop: '46px',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
  },
  saveForLaterProducts: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  laterMessage: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    flex: 1,
    minHeight: 200,
  },
  layout: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('xl')]: {
      paddingTop: theme.spacing(0),
    },
  },
  divider: {
    borderColor: colors.lightGrey,
    borderBottomWidth: 'medium',
    paddingTop: theme.spacing(6),
    width: '100vw',
  },
}));
